import React from 'react';
import PropTypes from 'prop-types';
import { isString, isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableHeaderCell = ({
  isHiddenOnXS,
  name,
  count,
  isButtonColumn,
  filteredCount,
  sortValue,
  sort,
  handleSort
}) => {
  let className = 'align-middle ';
  switch (true) {
    case isHiddenOnXS:
      className += 'd-none d-sm-table-cell';
      break;
    case isButtonColumn:
      className += 'text-center';
      break;
    default:
      break;
  }

  let cellName = name;
  if (!isString(count)) {
    cellName += ` (${count}) `;
  }

  const onCellClick = !isEmpty(sortValue) ? () => handleSort(sortValue) : () => {};

  return (
    <th className={className} onClick={onCellClick} style={{ cursor: 'pointer' }}>
      {cellName}
      {!isString(filteredCount) && (
        <span className="badge badge-pill badge-info d-none d-sm-inline">
          <FontAwesomeIcon icon="filter" className="mr-1" />
          {`Filtered (${filteredCount})`}
        </span>
      )}
      {sort[sortValue] === 1 && <FontAwesomeIcon icon="sort-up" className="ml-1" />}
      {sort[sortValue] === -1 && <FontAwesomeIcon icon="sort-down" className="ml-1" />}
    </th>
  );
};

TableHeaderCell.propTypes = {
  isHiddenOnXS: PropTypes.bool,
  isButtonColumn: PropTypes.bool,
  name: PropTypes.string,
  sortValue: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  filteredCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sort: PropTypes.object.isRequired,
  handleSort: PropTypes.func.isRequired
};

TableHeaderCell.defaultProps = {
  count: '',
  filteredCount: '',
  name: '',
  sortValue: '',
  isHiddenOnXS: false,
  isButtonColumn: false
};

export default TableHeaderCell;
